// Zugänge/Systemverbindungen (WordPress, easybooking Admin) – zeigt nur Status + Benutzername, nie Passwörter
import React, { useState, useEffect } from "react";
import axios from "axios";
import { KeyRound, CheckCircle2, XCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/settings/access-status`;

export function SystemAccess() {
  const [accesses, setAccesses] = useState(null);
  useEffect(() => { axios.get(API).then((r) => setAccesses(r.data.accesses)).catch(() => setAccesses([])); }, []);
  if (!accesses) return null;
  return (
    <div className="card max-w-3xl" data-testid="system-access">
      <div className="overline mb-1 flex items-center gap-2"><KeyRound size={14} /> Zugänge (WordPress &amp; easybooking)</div>
      <p className="text-sm text-eb-muted mb-3">Nur Status &amp; Benutzername – Passwörter bleiben ausschließlich in den sicher hinterlegten Schlüsseln.</p>
      <div className="space-y-2">
        {accesses.map((a) => (
          <div key={a.label} className="flex items-center gap-3 eb-surface rounded-md px-3 py-2 border border-white/5" data-testid={`access-row-${a.label}`}>
            {a.connected ? <CheckCircle2 size={16} className="text-emerald-400 shrink-0" /> : <XCircle size={16} className="text-rose-400 shrink-0" />}
            <div className="flex-1 min-w-0">
              <div className="text-sm truncate">{a.label}</div>
              <div className="text-[11px] text-eb-muted truncate">{a.connected ? `Verbunden · Benutzer: ${a.user}` : "Nicht verbunden"}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
